<template>
    <div class="layout-single">
        <text-headline-primary
            v-if="headline"
            class="headline-primary"
        >
            {{ headline }}
        </text-headline-primary>

        <slot />
        <div />
    </div>
</template>

<script>
export default {
    props: {
        headline: {
            type: String,
            required: false,
            default: null
        }
    }
};
</script>

<style scoped lang="scss">
.headline-primary {
    margin-top: 2rem;
}
</style>
